import React from "react";
import Field from "./Formfield";
import { useReferenceOptions } from "../../../hooks/useReferenceOptions";
import { OPERATION_COUNTRY_OPTIONS } from "./Tenantformoptions";
import "./OperationsTab.css";

const OperationsTab = ({ operations, errors, onChange, onAdd, onRemove }) => {
  const { options: industryOptions, loading: loadingIndustries } = useReferenceOptions('INDUSTRY');
  const { options: qualionOptions, loading: loadingQualion } = useReferenceOptions('QUALION_LEVEL');

  return (
    <div className="at-section">
      <h3 className="at-section__title">Operating Regions</h3>
      <p className="at-section__subtitle">
        Where this tenant runs, and whether registration is open in each region.
      </p>

      {errors["operations._general"] && (
        <p className="at-error-banner">{errors["operations._general"]}</p>
      )}

      <div className="at-op-list">
        {operations.map((op, index) => (
          <div className="at-op-card" key={op._key}>
            <div className="at-op-card__head">
              <span className="at-op-card__index">Region {index + 1}</span>
              {operations.length > 1 && (
                <button
                  type="button"
                  className="at-op-card__remove"
                  onClick={() => onRemove(index)}
                  aria-label="Remove region"
                >
                  ✕
                </button>
              )}
            </div>

            <div className="at-grid">
              <Field label="Industry" required error={errors[`operations.${index}.industry`]}>
                <select
                  value={op.industry}
                  onChange={(e) => onChange(index, "industry", e.target.value)}
                  disabled={loadingIndustries}
                >
                  <option value="">
                    {loadingIndustries ? "Loading industries..." : "Select industry"}
                  </option>
                  {industryOptions.map((o) => (
                    <option key={o.value} value={o.value}>
                      {o.label}
                    </option>
                  ))}
                </select>
              </Field>

              <Field label="Country" required error={errors[`operations.${index}.country_code`]}>
                <select
                  value={op.country_code}
                  onChange={(e) => onChange(index, "country_code", e.target.value)}
                >
                  <option value="">Select country</option>
                  {OPERATION_COUNTRY_OPTIONS.map((o) => (
                    <option key={o.value} value={o.value}>{o.label}</option>
                  ))}
                </select>
              </Field>

              <Field label="Region Name" required error={errors[`operations.${index}.region_name`]}>
                <input
                  value={op.region_name}
                  onChange={(e) => onChange(index, "region_name", e.target.value)}
                  placeholder="Texas"
                />
              </Field>
            </div>

            <div className="at-switch-row">
              <label className="at-switch">
                <input
                  type="checkbox"
                  checked={op.is_registration_enabled}
                  onChange={(e) => onChange(index, "is_registration_enabled", e.target.checked)}
                />
                <span className="at-switch__track"><span className="at-switch__thumb" /></span>
                <span className="at-switch__label">Registration Enabled</span>
              </label>

              <label className="at-switch">
                <input
                  type="checkbox"
                  checked={op.is_active}
                  onChange={(e) => onChange(index, "is_active", e.target.checked)}
                />
                <span className="at-switch__track"><span className="at-switch__thumb" /></span>
                <span className="at-switch__label">Active</span>
              </label>
            </div>

          
          </div>
        ))}
      </div>

      <button type="button" className="at-btn at-btn--dashed" onClick={onAdd}>
        + Add Another Region
      </button>
    </div>
  );
};

export default OperationsTab;